import React from 'react';
import Moment from 'moment';
import isUrl from '../utils/isUrl';


import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import IsTestField from '../components/notification/fields/IsTestField';
import UrlField from '../components/notification/fields/UrlField';
import MauticSegmentField from '../components/notification/fields/MauticSegmentField';
import ScheduleNotificationField from '../components/notification/fields/ScheduleNotificationField';
import NotificationBodyField from '../components/notification/fields/NotificationBodyField';

import _ from 'lodash';


export default class NotificationsContainer extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			application: '3ftlLhJYXpVqmP5joDcbVW',
			title: '',
			message: '',
			tags: '',
			titleError: '',
			messageError: '',
			tagsError: '',
			requesting: false,
			errorMsg: '',
			openConfirmationDialog: false,
			notSendPush: false,
			openUrl: false,
			openUrlOutsideApp: false,
			url: '',
			urlError: '',
			openAlertDialog: true,
			confirmButtonName: 'Ver agora',
			scheduleChecked: false,
			scheduledTime: null,
			scheduledDate: null,
			expirationHours: 72,
			isTest: false,
			testEmail: '',
			testEmailError: '',
			sendToMauticSegment: false,
			currentSegments: [],
			segmentList: []
		};

		this.onChangeField = this.onChangeField.bind(this);
		this.showConfirmationDialog = this.showConfirmationDialog.bind(this);
		this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
		this.clearForm = this.clearForm.bind(this);
		this.validate = this.validate.bind(this);
		this.submit = this.submit.bind(this);
	}

	componentDidMount() {
		this.props.fetchApi('get', '/segments')
			.then(response => {
				this.setState({ segmentList: response.data });
			}).catch(error => {
				console.error(error);
				this.setState({ fetchingInstallations: false, requesting: false, errorMsg: 'Ocorreu um erro ao listar segmentos do mautic' });
			});
	}

	onChangeField(field, value) {
		this.setState({
			[field]: value
		});
	}

	onChangeExpirationHours(value) {
		if (parseInt(value, 10) < 0) {
			this.setState({
				expirationHours: 0
			});
			return;
		}

		this.setState({
			expirationHours: parseInt(value, 10)
		});
	}

	onClickCheckBox = (field) => {
		this.setState((prevState) => {
			return {
				[field]: !prevState[field]
			};
		});
	}

	showConfirmationDialog() {
		this.setState({
			openConfirmationDialog: true
		});
	}

	closeConfirmationDialog() {
		this.setState({
			openConfirmationDialog: false
		});
	}

	clearForm() {
		this.setState({
			title: '',
			message: '',
			tags: '',
			openLink: false,
			openUrlOutsideApp: false,
			openUrl: false,
			notSendPush: false,
			url: '',
			openAlertDialog: true,
			confirmButtonName: 'Ver agora',
			scheduleChecked: false,
			scheduledTime: null,
			scheduledDate: null,
			expirationHours: 72,
			isTest: false,
			testEmail: '',
			testEmailError: '',
			sendToMauticSegment: false,
			currentSegments: []
		})
	}

	validate() {
		const title = this.state.title.trim();
		const message = this.state.message.trim();
		const tags = this.state.tags.trim();

		

		const { scheduleChecked, scheduledTime, scheduledDate, isTest, testEmail, sendToMauticSegment } = this.state;

		this.setState({
			titleError: '',
			messageError: '',
			tagsError: '',
			errorMsg: '',
			urlError: '',
			scheduleError: '',
			testEmailError: ''
		});

		const errors = {};

		if (!title) {
			errors.titleError = 'O título é obrigatório';
		}

		if (!message) {
			errors.messageError = 'A mensagem é obrigatória';
		} else if (message.length > 235) {
			errors.messageError = 'A mensagem pode ter no máximo 235 caracteres';
		}

		if (!tags) {
			errors.tagsError = 'As tags são obrigatórias';
		} else {
			const tagsWithWhitespace = tags.split(',').filter((tag) => tag.trim().includes(' '));

			if (tagsWithWhitespace.length > 0) {
				errors.tagsError = `As tags [${tagsWithWhitespace.join(',')}] não podem ter espaço em branco.`;
			}
		}

		if (scheduleChecked) {
			if (scheduledTime === null || scheduledDate === null) {
				errors.scheduleError = 'A data e a hora do agendamento devem ser preenchidos.';
			}
		}

		if (isTest === true && testEmail === '') {
			errors.testEmailError = 'O email de teste deve ser preenchido.';
		}

		if (sendToMauticSegment && isTest) {
			errors.testEmailError = 'Não é possível enviar uma notificação de teste e ao mesmo tempo envia-la para um segmento do mautic.';
		}

		if (Object.keys(errors).length > 0) {
			this.setState(errors);

		} else {
			this.showConfirmationDialog();
		}
	}

	submit() {
		this.closeConfirmationDialog();

		const { state } = this;

		this.setState({
			requesting: true
		});

		const application = state.application;
		const title = state.title.trim();
		const message = state.message.trim();
		const tags = state.tags.trim();
		const url = state.url.trim();
		const confirmButtonName = state.confirmButtonName.trim();
		const { scheduleChecked, sendToMauticSegment, currentSegments, segmentList } = this.state;

		let scheduledDate;
		if (scheduleChecked) {
			scheduledDate = Moment(this.state.scheduledDate);
			const scheduledTime = Moment(this.state.scheduledTime);

			scheduledDate.hour(scheduledTime.hour());
			scheduledDate.minutes(scheduledTime.minutes());
		}

		if (state.openUrl === true) {
			if (isUrl(url) === false) {
				this.setState({ urlError: 'Digite uma url válida.', requesting: false });
				return;
			}
		}

		if (sendToMauticSegment && currentSegments === null) {
			return;
		}

		this.props.fetchApi('post', '/notifications', {
			applicationId: application,
			title,
			message,
			tags: tags.split(',').map((tag) => tag.trim()),
			openUrl: state.openUrl,
			openUrlOutsideApp: state.openUrlOutsideApp,
			url,
			openAlertDialog: state.openAlertDialog,
			confirmButtonName,
			notSendPush: state.notSendPush,
			scheduledDate: Moment.utc(scheduledDate).format(),
			expirationHours: state.expirationHours > 0 ? state.expirationHours : 72,
			isTest: state.isTest,
			testEmail: state.testEmail,
			mauticSegments: sendToMauticSegment ? segmentList.filter(segment => currentSegments.includes(segment.name)) : null,
		}).then(response => {

			this.props.showSnackbar('A notificação está sendo enviada');
			this.setState({ requesting: false });

			if (state.isTest) {
				this.setState({
					testEmail: '',
					isTest: false
				});
			} else {
				this.clearForm();
			}

		}).catch(error => {
			console.log(error);
			this.setState({
				fetchingInstallations: false,
				requesting: false,
				errorMsg: _.get(error, 'message.response.data.errors[0].detail', 'Ocorreu um erro no envio das notificações'),
			});
		});
	}

	render() {
		const {
			application,
			title,
			message,
			tags,
			titleError,
			messageError,
			tagsError,
			requesting,
			errorMsg,
			openConfirmationDialog,
			openUrl,
			openUrlOutsideApp,
			url,
			urlError,
			openAlertDialog,
			confirmButtonName,
			notSendPush,
			scheduleChecked,
			scheduledTime,
			scheduledDate,
			scheduleError,
			expirationHours,
			isTest,
			testEmail,
			testEmailError,
			sendToMauticSegment,
			currentSegments,
			segmentList
		} = this.state;

		const confirmationDialogActions = [
			<Button
				key="cancel"
				variant="contained"
				onClick={this.closeConfirmationDialog}
			>
				Não
			</Button>,
			<Button
				key="confirm"
				variant="contained"
				color="primary"
				onClick={this.submit}
			>
				Sim
			</Button>
		];

		return (
			<div>
				<Card style={{ padding: '1rem' }}>
					<CardHeader
						title="Enviar Notificação Push"
					/>
					<form>
						<InputLabel shrink >
							Aplicação
						</InputLabel>
						<Select
							label="Aplicação"
							value={application}
							onChange={(event) => this.onChangeField('application', event.target.value)}
						>
							<MenuItem value="3ftlLhJYXpVqmP5joDcbVW">
								OAB de Bolso
							</MenuItem>
							<MenuItem value="40yXWykpgaVGXsnXrT8nCc">
								Concursos de Bolso
							</MenuItem>
						</Select>
						<br />
						<NotificationBodyField
							titleError={titleError}
							title={title}
							messageError={messageError}
							message={message}
							tagsError={tagsError}
							tags={tags}
							onChangeField={this.onChangeField}
						/>
						<br />
						<br />
						<div style={{ marginTop: '10px', marginBottom: '10px' }}>
							<label htmlFor="expirationHours" style={{ display: 'block', color: '#BBBBBB' }}>
								Expiração em horas
							</label>
							<input
								id="expirationHours"
								style={{ height: 20, border: 'none', borderBottom: '1px solid #DDDDDD', marginTop: 10, width: '100%', outline: 'none' }}
								type="number"
								value={expirationHours}
								onChange={(event) => this.onChangeExpirationHours(event.target.value)}
							/>
						</div>
						<br />
						<br />
						<ScheduleNotificationField
							scheduleChecked={scheduleChecked}
							scheduledDate={scheduledDate}
							scheduledTime={scheduledTime}
							scheduleError={scheduleError}
							onClickCheckBox={this.onClickCheckBox}
							onChangeField={this.onChangeField}
						/>
						<br />

						<FormControlLabel
							control={<Checkbox
								color="primary"
								checked={notSendPush}
								onChange={() => this.onClickCheckBox('notSendPush')}
								style={{ block: { maxWidth: 250 }, checkbox: { marginBottom: 16, } }}
							/>}
							label="Não enviar push notification"
						/>
						<br />
						<UrlField

							openUrl={openUrl}
							urlError={urlError}
							url={url}
							openUrlOutsideApp={openUrlOutsideApp}
							openAlertDialog={openAlertDialog}
							confirmButtonName={confirmButtonName}
							onChangeField={this.onChangeField}
							onClickCheckBox={this.onClickCheckBox}
						/>
						<MauticSegmentField
							sendToMauticSegment={sendToMauticSegment}
							currentSegments={currentSegments}
							segmentList={segmentList}
							onClickCheckBox={this.onClickCheckBox}
							onChangeField={this.onChangeField}
						/>
						<br />
						<IsTestField
							isTest={isTest}
							onClickCheckBox={this.onClickCheckBox}
							testEmailError={testEmailError}
							testEmail={testEmail}
							onChangeField={this.onChangeField}
						/>
						<Button variant="contained" color="primary" onClick={this.validate}>Enviar</Button>
						{requesting && <CircularProgress style={{ marginLeft: '1rem' }} />}
						{errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
					</form>
				</Card>
				<Dialog
					open={openConfirmationDialog}
				>
					<DialogContent>
						<DialogContentText>
							Deseja enviar a notificação?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						{confirmationDialogActions}
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Notifications.js